module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k4t3D"))).then(() => module.bundle.root('d0iPb'));